<template lang="pug">
  #signUpIndex
    .container-width.p-3
      #step1(v-if="nowStep == 1")
        .text-area-scroll.mb-2
          .line-text-header.mb-2
            .title.font-weight-bold 本服務限 {{ $companyName }} 員工使用
          .line-text-header.text-center.mb-2 請輸入您的資訊
        b-card.border-0.mb-2(
          bg-variant="light"
        )
          ValidationObserver(
            ref="userForm"
            tag="form"
            @submit.stop.prevent="submitHandler"
          )
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValSaCode",
                v-slot="{ errors }"
              )
                b-form-input.inputStyle(
                  id="saCode",
                  type="text",
                  required,
                  trim,
                  :state="validState('saCode')",
                  v-model="userForm.saCode",
                  aria-describedby="input-live-help input-saCode-live-feedback",
                  placeholder="請輸入員編"
                )
                b-form-invalid-feedback.text-center(
                  id="input-saCode-live-feedback"
                )
                  span {{ errors[0] }}
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValName",
                v-slot="{ errors }"
              )
                b-form-input.inputStyle(
                  id="name",
                  type="text",
                  required,
                  trim,
                  :state="validState('firstName')",
                  v-model="userForm.firstName",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入姓名"
                )
                b-form-invalid-feedback.text-center(
                  id="input-name-live-feedback"
                )
                  span {{ errors[0] }}
            b-form-group
              ValidationProvider(
                rules="required|mobile",
                ref="inputValMobile",
                v-slot="{ errors }"
              )
                b-form-input.inputStyle(
                  id="mobile",
                  type="tel",
                  required,
                  trim,
                  :state="validState('mobile')",
                  v-model="userForm.mobile",
                  aria-describedby="input-live-help input-mobile-live-feedback",
                  placeholder="請輸入手機"
                )
                b-form-invalid-feedback.text-center(
                  id="input-mobile-live-feedback"
                )
                  span {{ errors[0] }}
            b-form-group
              ValidationProvider(
                rules="required|verify",
                ref="inputValVerify",
                v-slot="{ errors }"
              )
                .row.no-gutters
                  .col-md-8.col-6.pr-1.d-flex.align-items-center.flex-wrap
                    b-form-input.w-100.verifyInput(
                      id="verify",
                      type="text",
                      required,
                      trim,
                      :state="validState('verify')",
                      v-model="userForm.verify",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="請輸入驗證碼"
                    )
                    b-form-invalid-feedback.w-100(
                      id="input-name-live-feedback"
                    )
                      span {{ errors.length === 0 ? '驗證碼錯誤' : errors[0] }}
                  .col-md-4.col-6.pl-1
                    .d-flex.align-items-center.justify-content-between
                      VerifyComponent(
                        ref="VerifyComponent"
                      )
                      i.fas.fa-sync-alt.fa-lg.refreshIcon.ml-2(
                        @click="changeVerifyCodeHandler"
                      )
        //- p.text-center.mb-3
        //-   code *字號
        //-   span 為選填選項，其餘選項皆為必填
        .px-4.fakePadding_h-50.position-relative
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom(
            type="button",
            @click="nextStepHandler()"
          )
            | 下一步
      #step2(v-if="nowStep == 2")
        .mb-4
          p.text-center 請輸入發送至您手機的驗證碼
        b-card.border-0.mb-2(
          bg-variant="light"
        )
          ValidationObserver(
            ref="mobileVerfityForm"
            tag="form"
            @submit.stop.prevent="mobileVerfityHandler"
          )
            b-form-group.mb-0
              ValidationProvider(
                rules="required",
                ref="inputValMobileVerfity"
              )
                b-form-input.inputStyle(
                  id="mobileVerfity",
                  type="text",
                  required,
                  trim,
                  :state="validverfityState()",
                  v-model="mobileVerfityCode",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入驗證碼"
                )
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span 簡訊驗證碼不可為空
              .text-center
                  .mt-2(
                    v-if="verfityNowTime == 0"
                  )
                    button.btn.btn-black.rounded-50.mt-2(
                      type="button",
                      @click="countDownHandler"
                    )
                      i.fas.fa-redo.fa-md.arrorIcon.pr-1
                      span 重發驗證碼
                  .mt-2(
                    v-else
                  )
                    code {{ verfityNowTime }}秒
                    span 後可重發驗證碼
        .px-4
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom(
            type="button",
            @click="nextStepHandler()"
          )
            | 下一步

</template>

<script>
import StepComponent from '@/components/step/StepComponent.vue'; // 客製化進度條
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import VerifyComponent from '@/components/verify/VerifyComponent.vue'; // 驗證套件
import { SA_SIGN_UP_SUCCESS } from '@/router/sa/sign-up';

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化身分證驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});

// 客製化驗證套件
extend('verify', {
  validate: (val) => {
    if (VerifyComponent.data.varifyAnswer === undefined) return true;
    return val === VerifyComponent.data.varifyAnswer ? true : false;
  },
  message: '驗證碼錯誤'
});

export default {
  name: 'SaSignUpIndex',
  components: {
    StepComponent,
    ValidationProvider,
    ValidationObserver,
    VerifyComponent
  },
  data() {
    return {
      stepArr: [
        { title: '簽署同意書' },
        { title: '輸入手機號碼' },
        { title: '手機簡訊驗證' },
        { title: '輸入個人資料' }
      ],
      nowStep: 1,
      agree_status: false,
      firstType: true, // 第一次進來輸入資料
      userForm: {
        lastName: null,
        firstName: null,
        saCode: null,
        mobile: null,
        verify: null
      },
      mobileVerfityCode: null,
      verfityTotalTime: 180,
      verfityNowTime: 0,
      verfityCanClick: true
    };
  },
  mounted() {
    const vm = this;
    // 檢查綁定狀態
    vm.$store.dispatch('sa_sign_up/checkBindingHandler')
      .then(() => {
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    async nextStepHandler() {
      const vm = this;
      switch (vm.nowStep.toString()) {
      case '1':
        vm.mobileNumberHandler();
        break;
      case '2':
        vm.mobileVerfityHandler();
        break;
      default:
        break;
      }
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      this.$swal.fire({
        title: '表單送出中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      // 送出並綁定
      vm.$store.dispatch('sa_sign_up/doBindingHandler', {
        chinese_first_name: vm.userForm.firstName,
        mobile: vm.userForm.mobile,
        sa_code: vm.userForm.saCode
      })
        .then(() => {
          this.$swal.close();
          vm.$router.push({
            name: SA_SIGN_UP_SUCCESS
          });
        });
    },
    // 檢查有無填寫手機號碼
    async mobileNumberHandler() {
      const vm = this;
      const isValid = await vm.$refs.userForm.validate();
      if (!isValid) {
        if (vm.userForm.lastName === null) {
          vm.userForm.lastName = '';
        }
        if (vm.userForm.firstName === null) {
          vm.userForm.firstName = '';
        }
        if (vm.userForm.saCode === null) {
          vm.userForm.saCode = '';
        }
        if (vm.userForm.mobile === null) {
          vm.userForm.mobile = '';
        }
        if (vm.userForm.verify === null) {
          vm.userForm.verify = '';
        }
        if (!vm.userForm.mobile) {
          vm.$swal.fire({
            icon: 'error',
            title: '請填寫手機號碼'
          });
        }
      } else {
        vm.countDownHandler();
        vm.nowStep = 2;
      }
    },
    // 送出手機驗證
    async mobileVerfityHandler() {
      const vm = this;
      const isValid = await vm.$refs.mobileVerfityForm.validate();
      if (!isValid) {
        if (vm.mobileVerfityCode === null) {
          vm.mobileVerfityCode = '';
        }
        if (!vm.mobileVerfityCode) {
          vm.$swal.fire({
            icon: 'error',
            title: '請填寫驗證碼'
          });
        }
      } else {
        vm.$swal.fire({
          title: '驗證中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        // 驗證簡訊驗證碼
        vm.$store.dispatch('sa_sign_up/validateSmsHandler', {
          mobile: vm.userForm.mobile,
          code: vm.mobileVerfityCode
        })
          .then(() => {
            vm.submitHandler();
          });
      }
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      if (vm.userForm[key] !== null) {
        if (key === 'mobile') {
          const MobileReg = /^(09)[0-9]{8}$/;
          return MobileReg.test(vm.userForm[key]);
        }
        if (key === 'email') {
          const EmailReg = /^[^\s]+@[^\s]+\.[^\s]{2,3}$/;
          return EmailReg.test(vm.userForm[key]);
        }
        if (key === 'verify') {
          return vm.userForm.verify === vm.$refs.VerifyComponent.varifyAnswer ? true : false;
        }
        return this.userForm[key] ? true : false;
      }
      return null;
    },
    mobileState() {
      const vm = this;
      if (vm.userForm.mobile !== null) {
        const MobileReg = /^(09)[0-9]{8}$/;
        return MobileReg.test(vm.userForm.mobile);
      }
      return null;
    },
    validverfityState() {
      const vm = this;
      if (vm.mobileVerfityCode !== null) {
        return this.mobileVerfityCode ? true : false;
      }
      return null;
    },
    // 倒數驗證碼
    async countDownHandler() {
      const vm = this;
      if (!vm.verfityCanClick) return;
      // 發送驗證碼
      vm.$store.dispatch('sa_sign_up/sendSmsValidateHandler', vm.userForm.mobile)
        .then(() => {
          vm.$snotify.success(null, '驗證碼已寄出');
          vm.verfityCanClick = false;
          vm.verfityNowTime = vm.verfityTotalTime;
          const clock = window.setInterval(() => {
            if (vm.verfityNowTime === 0) {
              window.clearInterval(clock);
              vm.verfityCanClick = true; // 這裡重新開啟
            } else {
              vm.verfityNowTime -= 1;
            }
          }, 1000);
        });
    },
    changeVerifyCodeHandler() {
      const vm = this;
      vm.$refs.VerifyComponent.changeVerifyCodeHandler();
    }
  }
};
</script>

<style>

</style>
